import { render } from "./TheStoryboxPage.vue?vue&type=template&id=0274cd1e&scoped=true&ts=true"
import script from "./TheStoryboxPage.vue?vue&type=script&lang=ts"
export * from "./TheStoryboxPage.vue?vue&type=script&lang=ts"

import "./TheStoryboxPage.vue?vue&type=style&index=0&id=0274cd1e&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0274cd1e"]])

export default __exports__